import React from 'react';
import GroupLightComponent from './configs/LightGroupConfig';

const LazerPagina = () => {
  return (
    <div className="lazer-container">
      <GroupLightComponent
        groupIds={["grupo18", "grupo19", "grupo20", "grupo21", "grupo22" ,"grupo23", "grupo24", 
          "grupo25", "grupo26", "grupo27", "grupo28", "grupo29", "grupo31",
          ]}
        pageId="2"
      />
    </div>
  );
};

export default LazerPagina;